import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0px 0px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
`;

export const AppliedCouponCodeContainer = styled.div`
  display: flex;
  margin: 5px 0px;
`;

export const CouponCode = styled.div`
  width: fit-content;
  border: 2px dotted #649942;
  padding: 2px;
  margin-left: 5px;
  margin-right: 4px;
  color: rgba(0, 0, 0, 0.63);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 0.8rem;
`;
export const DiscountAmount = styled.div`
  margin-left: 5px;
`;
